<template>
    <CreateServiceReport2></CreateServiceReport2>
</template>
<script>
    import CreateServiceReport2 from '@/components/CreateServiceReport2.vue'
    export default {
        name: 'employee-sign',
        components: {
            CreateServiceReport2
        }
    }
</script>